import type { Epic } from 'Flux/index.js'
import { billingSlice } from 'Flux/Slice/Billing/BillingSlice.js'
import { catchError, filter, forkJoin, map, mergeMap, of } from 'rxjs'

/**
 * Refresh just the credit balance + history. Dispatched by the `credit-transactions-changed`
 * websocket event (S2-955), the post-recharge poll, and the manual reload button — so every view
 * that reads the balance updates from a single fetch.
 */
export const ReloadCreditsEpic: Epic = (action$, _state$, { [billingSlice.name]: billing, BillingRepository }) =>
  action$.pipe(
    filter(billing.reloadCredits.match),
    mergeMap(() =>
      forkJoin({
        balance: BillingRepository.getCredits(),
        transactions: BillingRepository.getCreditHistory()
      }).pipe(
        map(({ balance, transactions }) => billing.creditsLoaded({ balance, transactions })),
        catchError((error) => of(billing.billingLoadFailed({ error })))
      )
    )
  )
